<template lang="pug">
div(
    :style="style"
    class="tl-grid"
)
    slot
</template>

<script setup>
import { computed, inject } from 'vue'
import { useBreakpoints } from '@/composables/ui/useBreakpoints'
import { getInjects } from '@/components/$tl/utils/injects'

const populateGrid = (obj) => {
    let out = ''
    if (typeof obj === 'number') {
        for (let i = 0; i < obj; i += 1) {
            out += '1fr '
        }
    } else {
        Object.values(obj).forEach((i) => {
            if (typeof i !== 'number') out += `${i} `
            else out += `${i}fr `
        })
    }
    return out
}

const props = defineProps({
    cols: {
        type: Array,
    },
    gap: {
        type: [Number, String],
    },
})

const injects = getInjects(props, inject)
const bp = useBreakpoints()

const cols = computed(() => props.cols ?? injects.cols ?? [1, 2, 3, 4])
const gap = computed(() => parseInt(props.gap, 10) || injects.gap || 20)

const computedCols = computed(() => {
    const model = cols.value ?? [1, 2, 3, 4]

    if (bp.phone.value) {
        return populateGrid(model[0])
    }

    if (bp.tablet.value) {
        if (model.length > 1) return populateGrid(model[1])
        return populateGrid(model[model.length - 1])
    }

    if (bp.notebook.value) {
        if (model.length > 2) return populateGrid(model[2])
        return populateGrid(model[model.length - 1])
    }

    if (bp.desktop.value) {
        if (model.length > 3) return populateGrid(model[3])
        return populateGrid(model[model.length - 1])
    }

    if (bp.display.value) {
        if (model.length > 4) return populateGrid(model[4])
        return populateGrid(model[model.length - 1])
    }

    return populateGrid(model[0])
})

const style = computed(() => ({
    gridTemplateColumns: computedCols.value,
    gridGap: `${gap.value}px`,
}))
</script>

<style lang="sass" scoped>
.tl-grid
    display: grid
</style>
